export default "__VITE_ASSET__ik6uq2ZQ__"